import React, { forwardRef, Ref, SVGProps } from 'react'

const _IconHomesAndVillasRectangle = (props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" {...props} ref={ref}>
    <rect x="0.199951" width="24" height="24" rx="6" fill="#F69464" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5843 18.8776V7.61203H16.5543L17.6015 5.90042V18.9087H16.5843V18.8776ZM7.54836 5.90042L8.59556 7.61203H8.56564V18.9087H7.54836V5.90042ZM11.7372 5.12241H13.4426L12.6049 6.52282L11.7372 5.12241ZM12.575 7.7054L14.1308 5.12241H15.3875L12.575 9.79046L9.76245 5.12241H11.0191L12.575 7.7054ZM12.575 13.027L7.78772 5.12241H9.04437L12.575 10.973L16.1055 5.12241H17.3622L12.575 13.027ZM14.9686 10.2573L15.9859 8.54564V18.8776H14.9686V10.2573ZM10.7797 18.8776H14.3702V17.3838H10.7797V18.8776ZM10.7797 13.4315V11.2531L12.0962 13.4315H10.7797ZM14.3702 13.4315H13.0537L14.3702 11.2531V13.4315ZM14.3702 15.112H10.7797V14.0539H12.4852H12.6647H14.3702V15.112ZM10.7797 16.7925H14.3702V15.7344H10.7797V16.7925ZM10.1813 10.2573V18.8776H9.16405V8.57676L10.1813 10.2573ZM6.94995 19.5H18.2V4.5H6.94995V19.5Z"
      fill="white"
    />
  </svg>
)

export const IconHomesAndVillasRectangle = forwardRef(_IconHomesAndVillasRectangle)
